export enum B2cPolicy {
  SignUpOrSignin = 'B2C_1A_JABRAHLE_SignUpOrSignin',
  SignUp = 'B2C_1A_JABRAHLE_SignUp',
}
